<template lang="html">
  <div id="presion" class="container-fluid" :class="">
    <div id="graficas" class="row" >
      <div id="line-charts" v-if="datacollection">
        <line-chart :height="400" ref="chart" :chartData="datacollection" :options="chartOps"></line-chart>
      </div>
    </div>
  </div>
</template>

<script>
  import LineChart from 'components/Charts/LineChart.js'
  import toastr from 'toastr'

  export default {
    data() {
      return {
        initial_loading: false,
        chartOps: {
          animation: false,
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{
              type: 'time',
              display: true,
              time: {
                unit: 'hour',
                displayFormats: {
                  day: 'MMM D',
                  hour: 'DD MMM,	HH:mm',
                },
                min: (new Date()).getTime() - 86400000,
                max: (new Date()).getTime() + 28800000,
                stepSize: 3
              },
            }],
            yAxes: [{
              ticks: {
                min: 1,
                max: 50,
                stepSize: 10,
                callback: function (value, index, values) { // needed to change the scientific notation results from using logarithmic scale
                  return Number(value.toString()) // pass tick values as a string into Number function
                }
              }
            }]
          }
        },
      date: this.$store.state.dpDate,
        option: this.$store.state.dpOpsHasta,
        option2: this.$store.state.dpOpsDesde,
        desde: '',
        hasta: '',
        tipo: 'FILTER_DATA',
        click: false,
        hastaEmpty: true,
        presion: null,
        pollTimer: null,
        datacollection: null,
        chartOptions: null,
        preasure: [],
        opDuctos: [],
        ductos: [],
        ducto: null,
        estaciones: [],
        estacion: null,
        opEstaciones: [],
        fechas: [],
        newestGpsTimestamp: -1,
        maxChart: 0,
        desdeText: '',
        hastaText: '',
        validation: false,
        showNewWindow: false,
      }
    },
    props: ['pdesde', 'phasta', 'pducto', 'pestacion'],
    methods: {
      updateInfo(data) {
        let section = Object.keys(data)[0]
        let labels = Object.keys(data[section])
        let datasets = []
        let colors = [
          '#e74c3c ',
          '#28b463 ',
          '#5dade2 ',
          '#f4d03f ',
          '#FFFFFF ',
          '#884ea0 ',
          '#e67e22 ',
          '#6c3483 ',
          '#f1948a ',
          '#45b39d ',
          '#76d7c4 ',
          '#c0392b ',
          '#d7bde2 ',
          '#2e86c1 ',
          '#117a65 ',
          '#d35400 ',
          '#239b56 ',
        ]

        let index = 0
        let didUpdate = false
        labels.forEach(station => {
          data[section][station].pressure.filter(yValue => {
            if(yValue.y >= this.maxChart) {
              this.maxChart = yValue.y
              didUpdate = true
            }
          })
        })
        if(didUpdate) {
          this.maxChart = Math.ceil(this.maxChart / 5) * 5
        }
        labels.forEach(station => {
          datasets.push({
            label: station,
            data: data[section][station].pressure,
            fill: false,
            backgroundColor: colors[index],
            borderColor: colors[index],
            pointBorderWidth: 1,
            borderWidth: 1,
            pointRadius: 0
          })
          index = index + 1
        })
        this.datacollection = {
          datasets: datasets
        }
        this.chartOps.scales.xAxes[0].time.min = this.desde
        this.chartOps.scales.xAxes[0].time.max = this.hasta

        for (let idx in this.datacollection.datasets) {
          let _dataSet = this.datacollection.datasets[idx]
          let _station = _dataSet.label
          let _data = _dataSet.data
          if (
            data[section] &&
            data[section][_station] &&
            data[section][_station].pressure
          ) {
            this.datacollection.datasets[idx].data = data[section][_station].pressure.concat(_data)
            let unixtime = Date.parse(data.newest_data)
            this.chartOps.scales.xAxes[0].time.max = unixtime
          }
        }
        let max
        this.hasta === 'null' ? max = new Date() : max = this.hasta
        let min = this.desde
        var timeDiff = Math.abs(new Date(max).getTime() - new Date(min).getTime())
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24))

        if(diffDays > 2) {
          this.chartOps.scales.xAxes[0].time.unit = 'day'
          this.chartOps.scales.xAxes[0].time.stepSize = 1
        } else {
          this.chartOps.scales.xAxes[0].time.unit = 'hour'
          this.chartOps.scales.xAxes[0].time.stepSize = 3
        }

        this.chartOps.scales.yAxes[0].ticks.max = this.maxChart

        this.maxChart <= 30 ? this.chartOps.scales.yAxes[0].ticks.stepSize = 5 : this.chartOps.scales.yAxes[0].ticks.stepSize = 10

        // this.$refs.chart._chart.update(0)
        // if(this.$store.state.cclick) {
        //   setTimeout(() => {
        //     let canvasEle = document.querySelector('#line-chart')
        //     canvasEle = canvasEle.toDataURL()
        //     let imgC = document.createElement('img')
        //     imgC.id = 'chartImg'
        //     imgC.src = canvasEle
        //     imgC.style = 'width:100%;'
        //     document.querySelector('#imgChart').innerHTML = ''
        //     document.querySelector('#imgChart').appendChild(imgC)
        //     this.$store.state.cclick = false
        //   }, 500)
        // }
      },

      fill(presion) {
        if (!presion || presion.length <= 0) {
          toastr.error('No se encontró información')
          return
        }

        this.initial_loading = true
        let data = {}
        let timestamps = {}
        presion.forEach(event => {
          if (!data[event['section_name']]) {
            data[event['section_name']] = {}
          }
          if (!data[event['section_name']][event['rtu_name']]) {
            data[event['section_name']][event['rtu_name']] = {}
            data[event['section_name']][event['rtu_name']].pressure = []
          }
          data[event['section_name']][event['rtu_name']].pressure.push({
            y: event.pressure,
            x: event.formated_date
          })
          timestamps[event['formated_date']] = event['formated_date']
        })
        this.updateInfo(data)
      },
      pollData(options) {
        this.$store.dispatch('GET_PRESION', {
          lastTimestamp: options.gpsTimestamp,
          ducto: options.ducto,
          estacion: options.estacion,
          desde: options.desde,
          hasta: options.hasta
        })
        .then((resp) => {
          if(!resp || !resp.data || resp.data.length <= 0) {
            toastr.error('No se encontró información')
          } else {
            this.fill(resp.data)
          }
        })
        .catch(err => {
          console.log(err)
          toastr.error(err)
        })
      }
    },
    watch: {
      cclick() {
        this.$store.state.cclick = true
        if(!this.desde && !this.ducto) {
           this.desde = this.pdesde
           this.hasta = this.phasta
           this.estacion = this.pestacion
           this.ducto = this.pducto
           document.querySelector('#line-charts').style.width = '100%'
        }

        setTimeout(() => {
        }, 500)
        this.pollData(this.options)
      }
    },
    mounted() {
      this.options = this.$route.query
      this.datacollection = null
      this.pollData(this.options)
    },
    components: {
      LineChart
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';
  .container-fluid {
    margin: 0;
    padding: 0;
    width:400vw;
    height:300vh;
    z-index:1;
    margin-top:-50px;
    background-color:#000;
  }
  canvas{
    background-color:black;
  }
  #presion {
    background-color: black;
    #formulario-top {
      margin-top: 80px;
      border-bottom: 1px solid $inactive;
    }

    #graficas {
      background-color: #000000;

      margin: 0;
      padding: 0;
      padding-top: 15vh;
    }

    .btn-default {
      margin-top: 0;
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
      @include celphone {
        margin-top: 50px;
      }
    }
  }


</style>



// WEBPACK FOOTER //
// CustomLineChart.vue?50c4efce